export default {
        firstToCreate: 'Be the first to create a thread in this forum',
        firstToPostInCategory: 'Be the first to post in this category',
        firstToRespondToTopic: 'Be the first to respond to this topic!',
        createNewThread: 'Create new thread',
        thread: 'thread',
        viewThread: 'View thread',
        replies: 'Replies',
        noReplies: 'No replies',
        reply: 'reply',
        _reply: 'Reply',
        ReplyTo: 'Reply to',
        replyToThisQuestion: 'Reply to this question',
        onceRepliedModeratorMayRespond: 'Once you have replied, the forum moderator may reply to your response',
        onceRepliedCanViewResponses: 'Once you have replied you can view other participants responses',
        loadingResponses: 'Loading responses',
        hideXReplies: 'Hide {count} replies',
        showXReplies: 'Show {count} replies',
        hideMostRecentReplies: 'Hide most recent replies',
        showMostRecentReplies: 'Show most recent replies',
        post: 'Post',
        message: 'Message',
        typeMessage: 'Type message',
        addPost: 'Add post',
        addMessage: 'Add message',
        editPost: 'Edit post',
        editPostWithMedia: 'Edit post with media',
        createPostWithMedia: 'Create post with media',
        deleteMessage: 'Delete message',
        deleteMessageConfirm: 'Are you sure you want to delete this message',
        pinPost: 'Pin post',
        media: 'Media',
        uploadMedia: 'Upload media',
        categories: 'categories',
        goBack: 'Go back',
        goBackPrevious: 'Go back to the previous page',
        goBackToCategory: 'Go back to {name} category',
        loadingLatestThreads: 'Loading latest threads',
        loadingDiscussionForum: 'Loading discussion forum',
        dontShowAgainForTask: `Don't show again for this task`,
        title: 'Title',
        beTheFirst: 'Be the first to reply to this thread'
};
